import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";
import { getCountry } from "../../../Slice/country.slice";
import { getBillHeaderId } from "../../../Slice/orderBillList.slice";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { leaveStructureJson } from "../../../DynamicFormsJson/MastersJSON/leaveStructure";
import RTTable from "../../../components/Comman/RT/RTTable";

class LeaveStructureView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
      leaveStructureDetailsList: [],
    };
  }

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        await apiGet({
          url: leaveStructureJson.apiBaseURL + "/" + this.props.params.id,
        }).then(({ data, success }) => {
          if (!success) {
          } else {
            let rowList = data.data.leaveStructureDetails.map(
              (companyObject, index) => {
                let newList = {
                  index: index + 1,
                  leaveType: companyObject.leaveType.name,
                  allotedLeaves: companyObject.allotedLeaves,
                  minimumDaysPerLeave: companyObject.minimumDaysPerLeave,
                  maximumDaysPerLeave: companyObject.maximumDaysPerLeave,
                  maximumCarryForwardDays: companyObject.maximumCarryForwardDays,
                  canBeEncashed: companyObject.canBeEncashed == 1 ? "Yes" : "No",
                };
                return newList;
              }
            );
            this.setState({
              leaveStructureDetailsList: rowList,
              DataToSet: [
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Leave Structure",
                  value:
                    data.data !== null && data.data.name !== null
                      ? data.data.name
                      : "",
                },
              ],
            });
          }
        });
        showLoador({ loador: false });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  render() {
    const { dynamicMasterData, DataToSet, leaveStructureDetailsList } =
      this.state;

    let isShowExtraFieldAtLeaveStructure =
      localStorage.getItem("isShowExtraFieldAtLeaveStructure") !== null ? localStorage.getItem("isShowExtraFieldAtLeaveStructure") : 0;

    const columns = [
      { title: "Sr.No.", name: "index", align: "center" },
      { title: "Leave Title", name: "leaveType" },
      { title: "No. of Leaves", name: "allotedLeaves", align: "center" },
      ...(isShowExtraFieldAtLeaveStructure == 1
        ? [
          { title: "Minimum Days Per Leave", name: "minimumDaysPerLeave", align: "center" },
          { title: "Maximum Days Per Leave", name: "maximumDaysPerLeave", align: "center" },
          { title: "Maximum Carry Forward Days", name: "maximumCarryForwardDays", align: "center" },
          { title: "Can Be Encashed ?", name: "canBeEncashed", align: "center" },
        ]
        : []),
    ];
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showTitle={true}
            screenTitle={"Leave Structure View"}
            fieldMeta={[]}
            apiBaseURL={leaveStructureJson.apiBaseURL}
            showSaveNextBtn={[]}
            saveBtnText={"Search"}
            showSaveBtnMain={false}
          />

          <RTTable
            columns={columns}
            tableData={leaveStructureDetailsList}
            isActionColActive={false}
            showPegination={false}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
  getBillHeaderId,
  getCountry,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(LeaveStructureView);
